import { useRouter } from 'vue-router'

export const componentState = () => {
  const router = useRouter()
  const fnConfirm = async () => {
    await router.replace({ path: '/main', query: { isRoot: 1 } })
  }
  return { fnConfirm }
}
